import styled, { css } from 'styled-components';

const commonHeaderStyles = css`
  font-weight: 600;
  margin: 0;
`;

export const H1 = styled.h1`
  ${commonHeaderStyles};
  font-size: 2.488em;
`;

export const H2 = styled.h2`
  ${commonHeaderStyles};
  font-size: 2.074em;
`;

export const H3 = styled.h3`
  ${commonHeaderStyles};
  font-size: 1.728em;
`;

export const H4 = styled.h4`
  ${commonHeaderStyles};
  font-size: 1.44em;
`;

export const H5 = styled.h5`
  ${commonHeaderStyles};
  font-size: 1.2em;
`;

export const Small = styled.small`
  font-size: 0.833em;
`;

export const Title = styled.h1`
  margin: 0;
  color: #444;
  font-size: 1.5rem;
  line-height: 1.375;
  font-weight: normal;
`;
